import {
  GET_SCR_V2_COMPLETE_DETAIL,
  GET_SCR_V2_REPORT_LIST,
  GET_SCR_V2_SUMMARY_REPORT,
} from "../../../Types";

const initialState = {
  list: {
    items: [],
    totalRecords: 0,
    pageNumber: 1,
    pageSize: 20,
  },
  detail: null,
  summary: null,
};

const SCRV2DetailReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SCR_V2_REPORT_LIST:
      return {
        ...state,
        list: action.payload || initialState.list,
      };
    case GET_SCR_V2_COMPLETE_DETAIL:
      return {
        ...state,
        detail: action.payload,
      };
    case GET_SCR_V2_SUMMARY_REPORT:
      return {
        ...state,
        summary: action.payload,
      };
    default:
      return state;
  }
};

export default SCRV2DetailReportReducer;
